import { getProductImage } from '../../services/products.service';
import { Utils } from '../constants/utilities.constants';
import { ProductImage } from '../product-card/models/product-image.model';
import { decodeImageService } from '../services/decode-image.service';
import React, { useEffect, useState } from 'react';
import styles from './product-thumbnail.module.scss';
import globalStyles from '../../global-styles.module.scss';
import classNames from 'classnames';
import defaultImage from '../../assets/img/Fixcenter-noimage.png';

interface IProductThumbnailProp {
    productId: string;
}

const ProductThumbnail: React.FC<IProductThumbnailProp> = ({ productId }) => {
    const [productImage, setProductImage] = useState<string>();

    const getImageByProductId = () => {
        if (!Utils.isNullOrUndefined(productId)) {
            getProductImage(productId).then((response: any) => {
                const image = response.data as ProductImage[];
                setProductImage(decodeImageService(image[0]?.content, image[0]?.name) as string);
            });
        }
    };

    useEffect(() => {
        getImageByProductId();
    }, [productId]);

    return (
        <div className={classNames(styles.container, globalStyles.float_left_item)}>
            <img src={productImage !== undefined ? productImage : defaultImage} alt="Product" />
        </div>
    );
};
export default ProductThumbnail;
